<template>
  <canvas
    :class="$style.canvas"
    :width="size"
    :height="size"
  />
</template>

<script>
import { number, arrayOf } from 'vue-types';

import useDonutDiagram from '@/hooks/useDonutDiagram';

export default {
  props: {
    size: number().def(440),
    values: arrayOf(number()).isRequired,
  },

  computed: {
    halfSize() {
      return `${this.size / 2}px`;
    },
  },

  watch: {
    values(next) {
      this.renderChart?.(next);
    },
  },

  mounted() {
    this.renderChart = useDonutDiagram(this.$el).render;
    this.renderChart(this.values);
  },
};
</script>

<style lang="scss" module>
.canvas {
  display: block;
  width: v-bind(halfSize);
  height: v-bind(halfSize);
}
</style>
